import { render, staticRenderFns } from "./RevenuesIndicator.vue?vue&type=template&id=2cc8ae6d&scoped=true"
import script from "./RevenuesIndicator.vue?vue&type=script&lang=js"
export * from "./RevenuesIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc8ae6d",
  null
  
)

export default component.exports